import { render } from "./dfdetail.vue?vue&type=template&id=016db631&scoped=true"
import script from "./dfdetail.vue?vue&type=script&lang=js"
export * from "./dfdetail.vue?vue&type=script&lang=js"

import "./dfdetail.vue?vue&type=style&index=0&id=016db631&lang=scss&scoped=true"
import "./dfdetail.vue?vue&type=style&index=1&id=016db631&lang=css"

import exportComponent from "D:\\workCode\\web-backEnd\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-016db631"]])

export default __exports__